import { Button, Text, mergeClasses } from '@fluentui/react-components';
import { useIconTextStyles } from './IconTextPair.styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface IconTextPairProps {
    icon: IconProp;
    text?: string;
    inverted?: boolean;
    id: string;
    onClick: () => void;
}

const IconTextPair = (props: IconTextPairProps) => {
    const { icon, text, inverted, id, onClick } = props;

    const styles = useIconTextStyles();

    return (
        <>
            <FontAwesomeIcon
                icon={icon}
                className={mergeClasses(styles.onlyIcon, styles.icon, inverted && styles.inverted)}
            />
            <Button id={id} className={styles.root} appearance='transparent' onClick={onClick}>
                <FontAwesomeIcon
                    icon={icon}
                    className={mergeClasses(styles.icon, inverted && styles.inverted)}
                />
                <Text className={mergeClasses(inverted && styles.inverted)}>{text}</Text>
            </Button>
        </>
    );
};

export default IconTextPair;
